module.exports = "/packs/005-980c8e8d981a9c5c118f4638036e5d5c.jpg";